module.exports = __webpack_public_path__ + "files/a9ee5e313e15a79700aac34beba8f3b1.svg";